module.exports = __webpack_public_path__ + "5444714dfc66e3dc94f503ad4cc1feb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nidrr-logo.png
// module id = 1059
// module chunks = 0